import {
  Component,
  OnInit,
  Injectable
} from '@angular/core';

import {
  NgbDateParserFormatter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';

import { FieldType } from '@ngx-formly/core';
import { MessageService } from '@shared/services/message.service';
import { environment } from '@environment/environment';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';

function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

function isNumber(value: any): boolean {
  return !isNaN(toInteger(value));
}

@Injectable()
export class NgbDateFRParserFormatter extends NgbDateParserFormatter {
  seperator = '.';

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split(this.seperator);
      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return { year: toInteger(dateParts[0]), month: null, day: null };
      } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        return { year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null };
      } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return { year: toInteger(dateParts[2]), month: toInteger(dateParts[1]), day: toInteger(dateParts[0]) };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    let stringDate = '';
    if (date) {
      stringDate += isNumber(date.day) ? padNumber(date.day) + this.seperator : '';
      stringDate += isNumber(date.month) ? padNumber(date.month) + this.seperator : '';
      stringDate += date.year;
    }
    return stringDate;
  }
}

@Component({
  selector: 'db-custom-field-date-picker',
  templateUrl: './custom-field-date-picker.component.html',
  styleUrls: ['./custom-field-date-picker.component.scss'],
  providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }]

})
export class CustomFieldDatePickerComponent extends FieldType implements OnInit {

  constructor(private messageService: MessageService, private service: QuestionnaireService) {
    super();
  }

  ngOnInit() {
  }

  editField(f) {
    // send message to subscribers via observable subject
    this.messageService.sendMessage(f.id);
    return false;
  }
  deleteField(field) {
    console.log('delete:' + field.id);
    this.messageService.sendMessage('delete:' + field.id);
    return false;

  }
  getSector(id) {
    return this.service.getSector(id);
  }

  showSector() {
    return environment.showSectors;
  }

}
